module.exports = __webpack_public_path__ + "static/img/egg_b_20.960f1bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_20.png
// module id = +9jp
// module chunks = 1